/** @jsxImportSource @emotion/react */
import React, { useContext } from 'react';
import { Product, ProductTypes } from '../../utils/types';
import ProductButton from '../../common/components/ProductButton/ProductButton';
import { OrderContext } from '../../common/providers/ContextProvider';
import { glassesNeedingPrescription } from '../../config/settings';
import { ShopifyProductSearch } from '../../api';

export default function UpsellSection() {
  const { orderData, parentProduct, setOrderData, getProductIsInOrder } = useContext(OrderContext);

  const addProduct = (upsell: Product) => {
    setOrderData(upsell, false);
  };

  const getUpsellIsInOrder = (product: Product) => {
    return getProductIsInOrder(product, false);
  };

  const upsellHandles = ShopifyProductSearch({
    parentType: parentProduct.type,
    productType: ProductTypes.Upsell,
    needsPrescription: glassesNeedingPrescription.includes(orderData.glasses?.id || 0),
  });
  return (
    <div>
      <h1>Tilleggsvalg</h1>
      {upsellHandles.map((handle) => (
        <ProductButton
          key={handle}
          handle={handle}
          setProduct={addProduct}
          isSelected={getUpsellIsInOrder}
        />
      ))}
    </div>
  );
}
